module.exports = __webpack_public_path__ + "media/photo/AdobeStock_195191757-7a052f87.jpg";